module.exports = __webpack_public_path__ + "img/slide15.ea7e60ec.png";